import { IStation } from 'dataSources/Typicode/stations/types/station';

const isActionItem = (item: IStation) => item.actions && !!item.actions.length;

export default isActionItem;
